import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache so the carrier list is fetched once per session.
let _carrierCache = null;

/**
 * Standardized ocean-carrier dropdown. Stores the canonical carrier NAME
 * (e.g. "CMA CGM") so backend tracking routes deterministically (CMA → CMA
 * Track & Trace API instead of SeaRates). Legacy free-text values are kept
 * selectable as a "(custom)" option so existing PFs never lose their value.
 */
export const CarrierSelect = ({
  value,
  onChange,
  className = "w-full mt-1 rounded-lg border-slate-200 text-sm h-10 px-3",
  testId = "shipping-line-select",
}) => {
  const [carriers, setCarriers] = useState(_carrierCache || []);

  useEffect(() => {
    if (_carrierCache) return;
    axios
      .get(`${API_URL}/tracking/carriers`)
      .then((r) => {
        const list = Array.isArray(r.data) ? r.data : (r.data?.carriers || []);
        _carrierCache = list.filter((c) => c.code !== "OTHER");
        setCarriers(_carrierCache);
      })
      .catch(() => {});
  }, []);

  const names = carriers.map((c) => c.name);
  const hasCustom = value && !names.includes(value);

  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className={className}
      data-testid={testId}
    >
      <option value="">Select carrier…</option>
      {carriers.map((c) => (
        <option key={c.code} value={c.name}>
          {c.name}
        </option>
      ))}
      {hasCustom && <option value={value}>{value} (custom)</option>}
    </select>
  );
};

export default CarrierSelect;
